/**
 * The version of the personal-data consent text this bundle shows, sent with every public booking
 * submission.
 *
 * **It lives beside the text on purpose.** The server holds the same constant and refuses any other
 * value, so a visitor on a page cached from before a wording change is turned away with a
 * validation error naming the checkbox — rather than having a record filed saying they agreed to
 * text nobody showed them. That only works while this constant and the wording travel together,
 * which is why it is not fetched from the server and not an application setting: either would let
 * the recorded version change while the deployed wording did not.
 *
 * **Changing `booking.consent` means changing this in the same commit**, and
 * `PersonalDataConsent.CurrentVersion` in `IpoDariger.Domain` with it. Dated rather than numbered so
 * the stored value says when the wording it names was written.
 */
export const PERSONAL_DATA_CONSENT_VERSION = '2026-09-05';
